import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import ShareholderSidebar from './ShareholderSidebar';
import ShareholderNavbar from './ShareholderNavbar';
import './AppLayout.css';

export default function ShareholderLayout() {
  const location   = useLocation();
  const activePage = location.pathname.split('/')[2] || 'dashboard';
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => { setSidebarOpen(false); }, [location.pathname]);

  return (
    <div className="layout">
      <ShareholderSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      {sidebarOpen && <div className="layout__overlay" onClick={() => setSidebarOpen(false)} />}
      <div className="layout__body">
        <ShareholderNavbar activePage={activePage} onToggleSidebar={() => setSidebarOpen((o) => !o)} />
        <main className="layout__content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
